import { Customer } from "./Customer";
import { UserCustomer} from "./UserCustomer";

export interface CustomerWithUserCustomers extends Customer{
    userCustomers: UserCustomer[];
}

export function CustomerWithUserCustomersFromJSON(json: any): CustomerWithUserCustomers {
    if((json === undefined) || (json === null)) {
        return json;
    }

    return {
        'id': json['id'],
        'created': json['created'] ? new Date(json['created']) : undefined,
        'customerNumber': json['customerNumber'],
        'userCustomers': json['userCustomers'],
        'name': json['name'],
    }
}

export function CustomerWithUserCustomersToJSON(value?: CustomerWithUserCustomers | null): any {
    if(value === undefined) {
        return undefined;
    }
    if(value === null) {
        return null;
    }
    return {
        'id': value.id,
        'customerNumber': value.customerNumber,
        'userCustomers': value.userCustomers,
        'name': value.name
    }
}